import React, { Suspense } from 'react';
import Scene3D from './Scene3D';

// Loading component for 3D assets
const LoadingScreen = () => {
  return (
    <div className="w-full h-screen bg-black flex items-center justify-center">
      <div className="text-white text-center space-y-4">
        <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="text-xl tracking-wider">LOADING 3D EXPERIENCE...</p>
      </div>
    </div>
  );
};

const Experience3D = ({ onClose }) => {
  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  return (
    <div className="relative w-full h-screen" onKeyDown={handleKeyDown} tabIndex={0}>
      {/* Close Button */}
      <button
        onClick={handleClose}
        className="absolute top-8 right-8 z-50 text-white text-sm tracking-wider hover:text-gray-300 transition-colors bg-black bg-opacity-50 px-4 py-2 rounded border border-white border-opacity-30"
        aria-label="Close 3D Experience"
      >
        CLOSE [ESC]
      </button>

      {/* 3D Scene with Suspense for loading */}
      <Suspense fallback={<LoadingScreen />}>
        <Scene3D />
      </Suspense>
    </div>
  );
};

export default Experience3D;
